export const YX_SALE_PLAN_LIST_PAGE_PATH = '/yx/salePlan/list'
